/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 设备监控-获取大分播机空闲格口数量 的 **请求配置**
 *
 * @分类 #4626
 * @请求头 `POST /erp/DeviceCut/getFreeGridCount`
 */
const postGetFreeGridCountRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/getFreeGridCount",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetFreeGridCount",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设备监控-获取大分播机空闲格口数量 的 **请求函数**
 *
 * @分类 #4626
 * @请求头 `POST /erp/DeviceCut/getFreeGridCount`
 */
export const postGetFreeGridCount = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetFreeGridCountRequestConfig, requestData),
    ...args
  );
};
postGetFreeGridCount.requestConfig = postGetFreeGridCountRequestConfig;
/**
 * 接口 设备监控-批量结束分播 的 **请求配置**
 *
 * @分类 #4626
 * @请求头 `POST /erp/DeviceCut/batchStopCut`
 */
const postBatchStopCutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/batchStopCut",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchStopCut",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设备监控-批量结束分播 的 **请求函数**
 *
 * @分类 #4626
 * @请求头 `POST /erp/DeviceCut/batchStopCut`
 */
export const postBatchStopCut = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBatchStopCutRequestConfig, requestData), ...args);
};
postBatchStopCut.requestConfig = postBatchStopCutRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取分播数据 的 **请求配置**
 *
 * @分类 #4586
 * @请求头 `POST /erp/DeviceCut/getCutData`
 */
const postGetCutDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/DeviceCut/getCutData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCutData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播数据 的 **请求函数**
 *
 * @分类 #4586
 * @请求头 `POST /erp/DeviceCut/getCutData`
 */
export const postGetCutData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetCutDataRequestConfig, requestData), ...args);
};
postGetCutData.requestConfig = postGetCutDataRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 分播日志 的 **请求配置**
 *
 * @分类 5846
 * @请求头 `POST /erp/DeviceCut/cutLog`
 */
const postCutLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/DeviceCut/cutLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCutLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 分播日志 的 **请求函数**
 *
 * @分类 5846
 * @请求头 `POST /erp/DeviceCut/cutLog`
 */
export const postCutLog = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCutLogRequestConfig, requestData), ...args);
};
postCutLog.requestConfig = postCutLogRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 无数据ID分播日志 的 **请求配置**
 *
 * @分类 #5794
 * @请求头 `POST /erp/DeviceCut/noDataIdCutLog`
 */
const postNoDataIdCutLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/DeviceCut/noDataIdCutLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postNoDataIdCutLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据ID分播日志 的 **请求函数**
 *
 * @分类 #5794
 * @请求头 `POST /erp/DeviceCut/noDataIdCutLog`
 */
export const postNoDataIdCutLog = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postNoDataIdCutLogRequestConfig, requestData),
    ...args
  );
};
postNoDataIdCutLog.requestConfig = postNoDataIdCutLogRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/deviceCut.js